/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'

// @mui icons
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import InstagramIcon from '@mui/icons-material/Instagram'

// Material Dashboard 2 React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import ProfileInfoCard from 'examples/Cards/InfoCards/ProfileInfoCard'
// import ProfilesList from 'examples/Lists/ProfilesList'
import DefaultProjectCard from 'examples/Cards/ProjectCards/DefaultProjectCard'

// Images
import homeDecor1 from 'assets/images/home-decor-1.jpg'
import homeDecor2 from 'assets/images/home-decor-2.jpg'
import homeDecor3 from 'assets/images/home-decor-3.jpg'
import homeDecor4 from 'assets/images/home-decor-4.jpeg'
import team1 from 'assets/images/team-1.jpg'
import team2 from 'assets/images/team-2.jpg'
import team3 from 'assets/images/team-3.jpg'
import team4 from 'assets/images/team-4.jpg'

import { useUserInfo } from 'context/user'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'

function Overview() {
  const [user] = useUserInfo()
  const AppService = useAppServices()

  const [tasks, setTasks] = useState([]);
  const [userTasks, setUserTasks] = useState([]);
  const [completedTaskPoints, setCompletedTaskPoints] = useState(0);

  const getTasks = async () => {
    const { response, error } = await AppService.tasks.get()
    if (response) {
      setTasks(response?.data);
      const filteredTasks = response?.data?.filter((task) => task.staff?.includes(user._id));
      setUserTasks(filteredTasks);

      const totalPoints = filteredTasks
        .filter((task) => task.status === 'completed') // Assuming 'status' is the field for task completion
        .reduce((sum, task) => sum + (task.points || 0), 0);

      setCompletedTaskPoints(totalPoints);
    }
  }
  console.log('user', user)
  useEffect(() => {
    getTasks()
  }, [])
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <MDBox mt={5} mb={3}>
        <Grid container spacing={1}>
          {/* <Grid item xs={12} md={6} xl={4}>
              <PlatformSettings />
            </Grid> */}
          <Grid item xs={12} md={6} xl={4} sx={{ display: 'flex' }}>
            <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
            <ProfileInfoCard
              title="profile information"
              description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
              info={{
                Name: user.username,
                email: user.email,
                mobile: user.phone,
                'Assigned Taks': userTasks?.length,
                Points: completedTaskPoints
              }}
              social={[
                {
                  link: 'https://www.facebook.com/CreativeTim/',
                  icon: <FacebookIcon />,
                  color: 'facebook',
                },
                {
                  link: 'https://twitter.com/creativetim',
                  icon: <TwitterIcon />,
                  color: 'twitter',
                },
                {
                  link: 'https://www.instagram.com/creativetimofficial/',
                  icon: <InstagramIcon />,
                  color: 'instagram',
                },
              ]}
              action={{ route: '', tooltip: 'Edit Profile' }}
              shadow={false}
            />
            <Divider orientation="vertical" sx={{ mx: 0 }} />
          </Grid>
          {/* <Grid item xs={12} xl={4}>
              <ProfilesList title="conversations" profiles={profilesListData} shadow={false} />
            </Grid> */}
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default Overview
